import React from 'react'
import { Drawer } from '../../../../shared/drawer/drawer'
import { Pill } from '../../../../shared/sso-workspace/pill'
import { dateTimeText, utcText } from '../../../../shared/date/local-time'
import { copyLines, registryCategories } from './consent-log-words'

const Row = ({ label, children }) => (children === null || children === undefined || children === '' ? null : <><dt>{label}</dt><dd>{children}</dd></>)

const Cookie = ({ cookie }) => (
  <li>
    <span className="sw-mono">{cookie.name}</span>
    {cookie.lifetime && <span className="sw-hint small">{` · ${cookie.lifetime}`}</span>}
    {cookie.purpose && <span className="sw-hint small d-block">{cookie.purpose}</span>}
  </li>
)

// One record opened: what was chosen and when, where from, and the version's
// cookie list and banner wording as they stood (the snapshot the website sent
// with that version).
export const SnapshotDrawer = ({ row, onClose }) => {
  const categories = registryCategories(row.snapshot && row.snapshot.registry)
  const lines = copyLines(row.snapshot && row.snapshot.copy)
  return (
    <Drawer open size="lg" title={`Record ${row.seq} · ${row.actionText}`} onClose={onClose}>
      <dl className="sw-dl">
        <Row label="Chosen">{row.chosenAt ? <time dateTime={row.chosenAt} title={utcText(row.chosenAt)}>{dateTimeText(row.chosenAt, { seconds: true })}</time> : ''}</Row>
        <Row label="Recorded">{row.recordedAt ? <time dateTime={row.recordedAt} title={utcText(row.recordedAt)}>{dateTimeText(row.recordedAt, { seconds: true })}</time> : ''}</Row>
        <Row label="Action">{row.actionText}</Row>
        <Row label="Banner">{`${row.bannerText}${row.modeText ? ` (${row.modeText} rules)` : ''}`}</Row>
        <Row label="Rules">{row.modeReasonText}</Row>
        <Row label="Privacy signal">{row.gpc ? 'The browser sent a privacy signal' : 'Not sent'}</Row>
        <Row label="Choices">{row.choicesText}</Row>
        <Row label="Location">{row.location}</Row>
        <Row label="IP address">{row.ipMasked}</Row>
        <Row label="Browser">{row.userAgent}</Row>
        <Row label="Page">{row.pagePath}</Row>
        <Row label="Site">{row.siteText}</Row>
        <Row label="Version"><span className="sw-mono">{row.version}</span></Row>
      </dl>

      <section aria-label="Cookies at this version">
        <h3 className="h6">Cookies at this version</h3>
        {categories.length === 0 && <p className="sw-hint">This version's cookie list isn't available.</p>}
        {categories.map(category => {
          const on = row.choices[category.key]
          return (
            <div key={category.key} className="mb-3">
              <h4 className="h6 mb-1">
                {category.label}{' '}
                {category.required ? <Pill>Always on</Pill> : on !== undefined && <Pill tone={on ? 'ok' : undefined}>{on ? 'Allowed' : 'Not allowed'}</Pill>}
              </h4>
              {category.description && <p className="sw-hint small mb-1">{category.description}</p>}
              {category.providers.length === 0 && <p className="sw-hint small mb-0">No providers.</p>}
              {category.providers.map(provider => (
                <div key={provider.id} className="ms-3 mb-2">
                  <strong>{provider.name}</strong>
                  {provider.purpose && <span className="sw-hint small d-block">{provider.purpose}</span>}
                  {provider.cookies.length > 0 && <ul className="mb-0">{provider.cookies.map(cookie => <Cookie key={cookie.name} cookie={cookie} />)}</ul>}
                </div>
              ))}
            </div>
          )
        })}
      </section>

      <section aria-label="Banner wording at this version">
        <h3 className="h6">Banner wording at this version</h3>
        {lines.length === 0 && <p className="sw-hint">This version's wording isn't available.</p>}
        {lines.length > 0 &&
          <dl className="sw-dl">
            {lines.map(line => <React.Fragment key={line.key}><dt className="sw-mono small">{line.key}</dt><dd>{line.value}</dd></React.Fragment>)}
          </dl>}
      </section>
    </Drawer>
  )
}
